import { useTranslation } from 'react-i18next';

import { Confirmation, Table, Visible, withQueryState } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { ButtonType, FormActions, Size } from 'coreOld/enums';
import { IAccessRank, IRank } from 'system/types';

import { RanksForm } from './RanksForm';

interface IProps {
  tableColumns;
  data: IAccessRank[];
  isLoading?: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  selectedItem?: FormActions | IRank | null;
  onCloseModal?: (reset) => void;
  onSubmit?;
  onRemove?: () => void;
  onConfirmRemove?: () => void;
  removedItem?: IRank | null;
  onCancelRemove?: () => void;
}

const UsersRanksView = ({
  tableColumns,
  data,
  isLoading,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  selectedItem,
  onCloseModal,
  onSubmit,
  onRemove,
  onConfirmRemove,
  removedItem,
  onCancelRemove,
}: IProps) => {
  const { t } = useTranslation();

  const messageConfirmation = (
    <>
      {t('messageConfirmRemoveRank', {
        rankName: (removedItem as IRank)?.rankName,
      })}
    </>
  );

  return (
    <>
      <RanksForm
        selectedItem={selectedItem as IRank}
        onCloseModal={onCloseModal}
        onSubmit={onSubmit}
        onRemove={onRemove}
      />

      <Visible when={Boolean(removedItem)}>
        <Confirmation
          isOpen={Boolean(removedItem)}
          onConfirm={onConfirmRemove}
          onCancel={onCancelRemove}
          title={t('labelRemoveRank')}
          confirmBtnLabel={t('buttonLabelRemove')}
          confirmBtnType={ButtonType.DANGER}
          size={Size.MD}
          message={messageConfirmation}
        />
      </Visible>

      <Table
        columns={tableColumns}
        data={data}
        name={TableNames.RANKS}
        hasRowSelection={false}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        borderBottom={true}
        borderRight={true}
        alternating={false}
      />
    </>
  );
};

export default withQueryState(UsersRanksView);
